/* This global function looks for either images or videos with a particular class and then fills out the image to its
* relative container to always make sure there are zero gaps with images and their containers at any and all
* resolutions. Can be used for banners, card background images, etc. */

window.loomisHelpers = {
  fillMediaToContainer: function() {

    let mediaArr = document.querySelectorAll(".js-fill-media-to-container"); // create array of images/videos

    if (mediaArr.length) {
      mediaArr.forEach((item, i)=> {
        let mediaContainer = item.closest("div, section");

        // get aspect ratio of image or video
        let mediaAspectRatio = item.clientWidth / item.clientHeight; // get item's height including padding

        // get aspect ratio of its container
        let mediaContainerAspectRatio = mediaContainer.clientWidth / mediaContainer.clientHeight;

        // if container is smaller than media, fill image horizontally. Else stretch vertically.
        if (mediaContainerAspectRatio < mediaAspectRatio) {
          item.classList.remove("fill-horizontally");
          item.classList.add('fill-vertically');
        } else {
          item.classList.remove("fill-vertically");
          item.classList.add("fill-horizontally");
        }
      });
    }
  }
}

window.addEventListener('load',  window.loomisHelpers.fillMediaToContainer);
window.addEventListener('resize', Drupal.debounce(window.loomisHelpers.fillMediaToContainer, 250)); // use Drupal's debounce function
